import { render, staticRenderFns } from "./teamMember.vue?vue&type=template&id=02bd270d&scoped=true&"
import script from "./teamMember.vue?vue&type=script&lang=js&"
export * from "./teamMember.vue?vue&type=script&lang=js&"
import style0 from "./teamMember.vue?vue&type=style&index=0&id=02bd270d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02bd270d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('02bd270d')) {
      api.createRecord('02bd270d', component.options)
    } else {
      api.reload('02bd270d', component.options)
    }
    module.hot.accept("./teamMember.vue?vue&type=template&id=02bd270d&scoped=true&", function () {
      api.rerender('02bd270d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8Ss7mg8owysBL/JS/teamMember.vue"
export default component.exports